<template>
  <div>
    <woot-modal :show.sync="showPopupDetails" :on-close="hidePopupDetails">
      <show
        :scheduled-list="getScheduledList"
        @on-delete-click="openDeletePopup"
      />
    </woot-modal>

    <woot-modal :show.sync="showPopupCreate" :on-close="hidePopupCreate">
      <create @on-close="hidePopupCreate" />
    </woot-modal>

    <woot-delete-modal
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('INBOX_MGMT.TEMPLATES.DELETE.CONFIRM.TITLE')"
      :message="$t('INBOX_MGMT.TEMPLATES.DELETE.CONFIRM.MESSAGE')"
      :confirm-text="$t('INBOX_MGMT.TEMPLATES.DELETE.CONFIRM.YES')"
      :reject-text="$t('INBOX_MGMT.TEMPLATES.DELETE.CONFIRM.NO')"
      :is-loading="uiFlags.isDeleting"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Create from './Create';
import Show from './Show';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  components: {
    Create,
    Show,
  },
  mixins: [alertMixin],
  props: {
    showPopupCreate: {
      type: Boolean,
      default: false,
    },
    showPopupDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDeleteConfirmationPopup: false,
      scheduledToDelete: null,
    };
  },
  computed: {
    ...mapGetters({
      getScheduledList: 'scheduledMessages/getScheduledList',
      uiFlags: 'scheduledMessages/getUIFlags',
    }),
  },
  methods: {
    ...mapActions('scheduledMessages', ['delete']),
    hidePopupCreate() {
      this.$emit('hide-popup-create');
    },
    hidePopupDetails() {
      this.$emit('hide-popup-details');
    },
    openDeletePopup(scheduled) {
      this.scheduledToDelete = scheduled;
      this.showDeleteConfirmationPopup = true;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
      this.scheduledToDelete = null;
    },
    async confirmDeletion() {
      if (!this.scheduledToDelete) return;

      try {
        await this.delete(this.scheduledToDelete.id);
        this.showAlert(this.$t('SCHEDULED_MESSAGE.DELETE.API.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(this.$t('SCHEDULED_MESSAGE.DELETE.API.ERROR_MESSAGE'));
      } finally {
        this.closeDeletePopup();
        this.hidePopupDetails();
      }
    },
  },
};
</script>

<style scoped>
.scheduled-item {
  padding: var(--space-one);
  border-bottom: 1px solid var(--b-100);
  cursor: pointer;
}

.scheduled-item:hover {
  background: var(--b-50);
}
</style>
